import { Routes } from '@angular/router';

import { CAN_ACTIVATE_AUTH_GUARD } from '@auth/guards/can-activate.auth.guard';
import { DEFAULT_ROUTE_GUARD } from '@core/guards/default-route.guard';
import { PowerBiEmbedContainerComponent } from '@power-bi/containers/power-bi-embeded-container/power-bi-embed-container.component';
import { ClientSetupComponent } from '@shared/components/client-setup/client-setup.component';
import { ErrorComponent } from '@shared/components/error/error.component';
import { PageNotFoundComponent } from '@shared/components/page-not-found/page-not-found.component';

export const APP_ROUTES: Routes = [
  {
    path: ':clientId/:reportId/main',
    component: PowerBiEmbedContainerComponent,
    canActivate: [CAN_ACTIVATE_AUTH_GUARD]
  },
  {
    path: 'client-setup',
    component: ClientSetupComponent,
    data: { title: 'Client Setup' }
  },
  {
    path: 'error',
    component: ErrorComponent,
    pathMatch: 'full',
    data: { title: 'Error' }
  },
  {
    path: '',
    pathMatch: 'full',
    component: PageNotFoundComponent,
    canActivate: [DEFAULT_ROUTE_GUARD]
  },
  { path: '**', component: PageNotFoundComponent }
];
